import React, { useState } from 'react';

import TextField from '@material-ui/core/TextField';

const DateInput = ({ accessor, onChange }) => {
  const formateData = (date) => {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0];
  };

  let [value, setValue] = useState(new Date());

  const onChng = (e) => {
    setValue(e.target.value);
    onChange({ accessor, value: e.target.value });
  };

  return (
    <TextField
      id="date"
      type="date"
      variant="outlined"
      size="small"
      defaultValue={formateData(new Date(value))}
      value={formateData(new Date(value))}
      onChange={onChng}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

export default DateInput;
